import { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useCookieConsent } from "../../context/CookieConsentContext";

export default function TrustPilotButton() {
  const { consent, openPreferences } = useCookieConsent();

  useEffect(() => {
    if (consent.marketing && window.Trustpilot) {
      window.Trustpilot.loadFromElement(
        document.querySelector(".trustpilot-widget"),
        true
      );
    }
  }, [consent.marketing]);

  if (!consent.marketing) {
    return (
      <Box sx={{ marginTop: "1rem" }}>
        <Typography variant="body2" sx={{ color: "#7A8699" }}>
          Enable marketing cookies to view our Trustpilot reviews.
        </Typography>
        <Button
          size="small"
          onClick={openPreferences}
          sx={{ mt: 0.5, pl: 0, color: "#1C6B76" }}
        >
          Cookie Settings
        </Button>
      </Box>
    );
  }

  return (
    <div
      style={{ marginTop: "1rem" }}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="695e35f5996fbae4881423d7"
      data-style-height="52px"
      data-style-width="100%"
      data-token="f1df7bbf-3173-4569-9e86-969f88767a0d"
    >
      <a
        href="https://www.trustpilot.com/review/elifesavingmedicine.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
}
